import { render, staticRenderFns } from "./payment_rank.vue?vue&type=template&id=29ed8bbe&"
import script from "./payment_rank.vue?vue&type=script&lang=ts&"
export * from "./payment_rank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports